import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import Header from '../components/layout/header/header'
import Footer from '../components/layout/footer/footer'
import { HandleTracking } from '../helpers/handleTracking'
import { OperatorDisclosureBanner } from '../components/layout/operatorDisclosureBanner'

declare global {
    interface Window {
        dataLayer: any
    }
}

function Main() {
    HandleTracking()

    return (
        <div className="main">
            <Header />
            <OperatorDisclosureBanner />
            <Outlet />
            <Footer />
        </div>
    )
}

export default Main
